webpackJsonp([2],{

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_echarts__);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__router_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__store_index__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return app; });








__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.baseURL = 'https://free-api.heweather.com/v5'
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.params = {
    city: '127.0.0.1', //根据本机 ip 获取城市
    key: '6fcd1f55dc9d4c059b6ae73ec24f2ce2' // 生成的 key
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_6_echarts___default.a;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */])

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */](Object.assign({}, {router: __WEBPACK_IMPORTED_MODULE_4__router_index__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* default */]},
    __WEBPACK_IMPORTED_MODULE_2__App_vue___default.a))



/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(undefined);
// imports


// module
exports.push([module.i, "a,abbr,acronym,address,applet,big,blockquote,body,caption,cite,code,dd,del,dfn,div,dl,dt,em,fieldset,form,h1,h2,h3,h4,h5,h6,html,iframe,img,ins,kbd,label,legend,li,object,ol,p,pre,q,s,samp,small,span,strike,strong,sub,sup,table,tbody,td,tfoot,th,thead,tr,tt,ul,var{margin:0;padding:0;border:0;outline:0;font-weight:inherit;font-style:inherit;font-family:inherit;font-size:100%;vertical-align:baseline}body{line-height:1;color:#000;background:#fff}ol,ul{list-style:none}a,abbr,acronym,address,caption,code,dd,del,dfn,div,dl,dt,em,fieldset,form,h1,h2,h3,h4,h5,h6,iframe,img,label,legend,li,object,ol,p,pre,span,tbody,tfoot,thead,tr,ul{margin:0;padding:0;border:0;outline:0;font-weight:inherit;font-style:inherit;font-family:inherit;font-size:100%;vertical-align:baseline}table{border-collapse:separate;border-spacing:0}caption,table,td,th{vertical-align:middle}caption,td,th{text-align:left;font-weight:400}a img{border:none}body,html{height:100%}body{background-color:#eee;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,SimSun,sans-serif;font-size:100%;line-height:1.618}h1{font-size:2rem;font-weight:700}h1,p{padding:10px 0}a{color:#108ee9;text-decoration:none;transition:color .25s cubic-bezier(1,.5,.8,1),background-color .25s cubic-bezier(1,.5,.8,1)}a:hover{color:#4dba87}.img--responsive{max-width:100%;height:auto;display:block}.center{text-align:center}.center--block{margin:0 auto}", ""]);

// exports


/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(undefined);
// imports


// module
exports.push([module.i, "body[data-v-06031f34],html[data-v-06031f34]{height:100%}.refresh[data-v-06031f34]{position:fixed;bottom:50px;right:40px;height:58px;width:58px;border:0;border-radius:50%;background-color:#eee;box-shadow:0 0 3px 5px #eee}#app[data-v-06031f34]{height:100%;background-color:#fff}#app .swiper .swiper-roll[data-v-06031f34],#app .swiper[data-v-06031f34]{height:100%}#app .swiper .weather-info[data-v-06031f34]{font-size:1.5rem}#app .swiper .weather-info #content[data-v-06031f34]{height:100%;display:flex;flex-flow:column nowrap;justify-content:center;align-items:center}#app .swiper .weather-info #content .main-tmp span[data-v-06031f34]{font-size:5rem;font-weight:600}#app .swiper .weather-info #content .line[data-v-06031f34]{margin:0 auto 10px;display:block;width:70%;text-align:center;background-color:#000;height:3px;border-radius:50%}#app .swiper .weather-details[data-v-06031f34]{display:flex;flex-flow:column nowrap;color:#333}#app .swiper .weather-details .sm-info[data-v-06031f34]{text-align:center;font-size:1rem;margin:10px}#app .swiper .weather-details .main-content #tem-chart[data-v-06031f34]{margin-top:-30px;width:100%;height:250px}#app .swiper .weather-details .main-content .detail-infos[data-v-06031f34]{margin-top:-20px;width:100%}#app .swiper .weather-details .main-content .detail-infos .text-block[data-v-06031f34]{margin:10px 0}#app .swiper .weather-details .main-content .detail-infos .text-block p[data-v-06031f34]{padding:0;display:flex;flex-flow:row nowrap}#app .swiper .weather-details .main-content .detail-infos .text-block p span[data-v-06031f34]{padding:0 10px;width:50%;font-weight:200}#app .swiper .weather-details .main-content .detail-infos .text-block p [data-v-06031f34]:first-child{text-align:right}#app .swiper .weather-details footer[data-v-06031f34]{padding:10px;font-size:1rem;flex:1 0 auto;display:flex;justify-content:center;align-items:flex-end}#app .swiper .weather-details footer a[data-v-06031f34]{color:#333}", ""]);

// exports


/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(63)(undefined);
// imports


// module
exports.push([module.i, ".swiper[data-v-0ede842b]{position:relative;overflow:hidden}.swiper .swiper-wrap[data-v-0ede842b]{display:-ms-flexbox;display:box;display:flex;width:100%;height:100%;transition:all 0ms ease}.swiper .swiper-wrap section[data-v-0ede842b]{overflow:hidden;flex-shrink:0;width:100%;height:100%}.swiper.horizontal .swiper-wrap[data-v-0ede842b]{-o-box-orient:horizontal;flex-direction:row}.swiper.vertical .swiper-wrap[data-v-0ede842b]{-o-box-orient:vertical;flex-direction:column}.swiper .swiper-pagination[data-v-0ede842b]{position:absolute}.swiper .swiper-pagination-bullet[data-v-0ede842b]{width:8px;height:8px;border-radius:50%;background-color:#000;opacity:.2;-ms-filter:\"progid:DXImageTransform.Microsoft.Alpha(Opacity=20)\";filter:alpha(opacity=20);transition:all .5s ease}.swiper .swiper-pagination-bullet.active[data-v-0ede842b]{background:#007aff;opacity:1;-ms-filter:none;filter:none}.swiper.vertical .swiper-pagination[data-v-0ede842b]{right:10px;top:50%;transform:translate3d(0,-50%,0)}.swiper .swiper-pagination-bullet[data-v-0ede842b]{display:block;margin:6px 0}.swiper.horizontal .swiper-pagination[data-v-0ede842b]{bottom:10px;width:100%;text-align:center}.swiper .swiper-pagination-bullet[data-v-0ede842b]{display:inline-block;margin:0 3px}", ""]);

// exports


/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(161);



// prime the store with server-initialized state.
// the state is determined during SSR and inlined in the page markup.
if (window.__INITIAL_STATE__) {
    __WEBPACK_IMPORTED_MODULE_1__app__["a" /* store */].replaceState(window.__INITIAL_STATE__)
}

// wait until router has resolved all async before hooks
// and async components...
__WEBPACK_IMPORTED_MODULE_1__app__["b" /* router */].onReady(function () {
    // actually mount to DOM
    __WEBPACK_IMPORTED_MODULE_1__app__["c" /* app */].$mount('#app')
})

// service worker
if ("production" === 'production' && 'serviceWorker' in navigator) {
    navigator.serviceWorker.register('/iWeAther-APP/sw.js')
}

/***/ }),

/***/ 186:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(205);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */])

// Codesplit based on route
// const Home = ()=> System.import('pages/Home')
// const Test = ()=> System.import('pages/Test')
var NotFound = function () { return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 479)); }

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'hash',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        var ret = {
            x: 0,
            y: 0
        }
        if (to.hash) {
            ret = {
                selector: to.hash
            }
        } else if (savedPosition) {
            ret = savedPosition
        }
        return ret
    },
    routes: [{
        path: '*',
        name: 'NotFound',
        component: NotFound
    }]
}));

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getData: function (ref, actions){
        var dispatch = ref.dispatch;

        return Promise.all(actions.map(function (action){ return dispatch(action); }));
},
    // Fake Async API Calls
    getTestTitle: function (ref){
        var commit = ref.commit;

        return new Promise(function (resolve){
        setTimeout(function (){
            commit('SET_TEST_TITLE', 'Test | iWeAther-APP')
            resolve()
        }, 1000)
    });
},
    getTestContent: function (ref){
        var commit = ref.commit;

        return new Promise(function (resolve){
        setTimeout(function (){
            commit('SET_TEST_CONTENT', 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nam recusandae, repudiandae corrupti dolor earum quibusdam molestiae obcaecati perspiciatis repellendus sequi a quod ea praesentium maxime unde architecto dignissimos non ipsum mollitia, fugiat qui, quo enim accusamus. Id similique voluptatibus facilis, ad perferendis distinctio consequatur impedit, dolorem repellendus ab ipsa. Necessitatibus.')
            resolve()
        }, 1000)
    });
}
});


/***/ }),

/***/ 188:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(189);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */])

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
    actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */]
}));


/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    SET_TEST_TITLE: function SET_TEST_TITLE(store, title) {
        store.testTitle = title
    },
    SET_TEST_CONTENT: function SET_TEST_CONTENT(store, content) {
        store.testContent = content
    }
});


/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    testTitle: '',
    testContent: ''
});


/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_swiper__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vue_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_vue_swiper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'App',
    data: function data() {
        return {
            "basic": {
                "city": "",
                "update": { "loc": "" }
            },
            "now": {
                "hum": "",
                "fl": "",
                "vis": "",
                "wind": {},
                "cond": {
                    "txt": ''
                }
            },
            "chartsOptions": {
            },
            "daily_forecast": [],
            "afterCalculater": {
                "maxTmps": [],
                "minTmps": [],
                "xDate": []
            },
            "cool": {
                "oldLocation": 0
            }
        }
    },
    components: { Swiper: __WEBPACK_IMPORTED_MODULE_0__components_vue_swiper___default.a },
    mounted: function mounted() {
        return this.getWeathers();
    },
    methods: {
        view: function view(ref) {
            var title = ref.title;
            var description = ref.description;
            var keywords = ref.keywords;

            if (title) {
                document.title = title
            }
            if (description) {
                document.head.querySelector('meta[name=description]').content = description
            }
            if (keywords) {
                document.head.querySelector('meta[name=keywords]').content = keywords
            }
        },
        getWeathers: function () {
            var self = this
            self.$http.get('/now').then(function (response) {
                self.now = response.data.HeWeather5[0].now;
                self.basic = response.data.HeWeather5[0].basic;
            }).catch(function (error) {
                throw new Error(error);
            })

            self.$http.get('/forecast').then(function (response) {
                self.daily_forecast = response.data.HeWeather5[0].daily_forecast;
            }).then(function () {
                self.calcuTems(self.daily_forecast)
            }).then(function () {
                self.renderCharts();
            }).catch(function (error) {
                throw new Error(error);
            })
            console.log('GetWeathers')
        },
        calcuTems: function (temArr) {
            var ref = [[], [], []];
            var temMaxs = ref[0];
            var temMins = ref[1];
            var xDate = ref[2];
            temArr.forEach(function (item, i) {
                temMaxs.push(item.tmp.max);
                temMins.push(item.tmp.min);
                xDate.push(i == 0 ? '今天' : Number(item.date.split('-')[1]) + '-' + Number(item.date.split('-')[2]));

            })
            this.afterCalculater = { maxTmps: temMaxs, minTmps: temMins, xDate: xDate };
            console.log(temMaxs, temMins);
        },
        onSlideChangeStart: function (currentPage) {
            console.log('onSlideChangeStart', currentPage);
            if (currentPage === 1) {
                this.cool.oldLocation = 0;
            } else {
                this.cool.oldLocation = parseInt(window.screen.height / 3)
            }
        },
        formatTime: function (timeString) {
            return Number(timeString.split(' ')[0].split('-')[1]) + '月' + Number(timeString.split(' ')[0].split('-')[2]) + '日'
        },
        startFreshPlay: function () {
            this.svgRun()
            this.getWeathers()
        },
        svgRun: function () {
            var path = document.querySelector('.refresh path');
            var length = path.getTotalLength();
            path.style.transition = path.style.WebkitTransition = 'none';
            path.style.strokeDasharray = length + ' ' + length;
            path.style.strokeDashoffset = length;

            path.getBoundingClientRect();
            path.style.transition = path.style.WebkitTransition = 'stroke-dashoffset 2s ease-in-out';
            path.style.strokeDashoffset = '0';
        },
        renderCharts: function () {
            var self = this;
            var myChart = this.$echarts.init(document.getElementById('tem-chart'));
            myChart.setOption({
                "xAxis": {
                    "type": 'category',
                    "boundaryGap": false,
                    "data": self.afterCalculater.xDate
                },
                "yAxis": {
                    "show": false,
                    "type": 'value',
                    "min": 'dataMin',
                    "max": 'dataMin',
                    "axisLabel": {
                        "formatter": '{value} °C'
                    }
                },
                "series": [
                    {
                        "name": '最高气温',
                        "type": 'line',
                        "lineStyle": {
                            "normal": {
                                "width": 1,
                                "color": '#f04134',
                                "type": 'solid'
                            }
                        },
                        "data": self.afterCalculater.maxTmps,
                        "markLine": {
                            "data": [
                                { "type": 'average', "name": '平均值' }
                            ]
                        }
                    }, {
                        "name": '最低气温',
                        "type": 'line',
                        "lineStyle": {
                            "normal": {
                                "width": 1,
                                "color": '#7265e6',
                                "type": 'solid'
                            }
                        },
                        "data": self.afterCalculater.minTmps,
                        "markLine": {
                            "data": [
                                { "type": 'average', "name": '平均值' } ]
                        }
                    }
                ]
            });
        },
    }
});


/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var VERTICAL = 'vertical';
var HORIZONTAL = 'horizontal';

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        direction: {
            type: String,
            default: VERTICAL,
            validator: function (value) { return [VERTICAL, HORIZONTAL].indexOf(value) > -1; }
        },
        mousewheelControl: {
            type: Boolean,
            default: true
        },
        performanceMode: {
            type: Boolean,
            default: false
        },
        paginationVisible: {
            type: Boolean,
            default: false
        },
        paginationClickable: {
            type: Boolean,
            default: false
        },
        loop: {
            type: Boolean,
            default: false
        },
        speed: {
            type: Number,
            default: 500
        }
    },
    data: function data() {
        return {
            currentPage: 1,
            lastPage: 1,
            translateX: 0,
            translateY: 0,
            startTranslate: 0,
            delta: 0,
            dragging: false,
            startPos: null,
            transitioning: false,
            slideEls: [],
            translateOffset: 0,
            transitionDuration: 0
        };
    },
    mounted: function mounted() {
        this._onTouchMove = this._onTouchMove.bind(this);
        this._onTouchEnd = this._onTouchEnd.bind(this);
        this.slideEls = [].map.call(this.$refs['swiper-wrap'].children, function (el) { return el; });
        if (this.loop) {
            this.$nextTick(function () {
                console.log(this)
                this._createLoop();
                this.setPage(this.currentPage, true);
            });
        } else {
            this.setPage(this.currentPage);
        }
    },
    methods: {
        next: function next() {
            var page = this.currentPage;
            if (page < this.slideEls.length || this.loop) {
                this.setPage(page + 1);
            } else {
                this._revert();
            }
        },
        prev: function prev() {
            var page = this.currentPage;
            if (page > 1 || this.loop) {
                this.setPage(page - 1);
            } else {
                this._revert();
            }
        },
        setPage: function setPage(page, noAnimation) {
            var self = this;
            this.lastPage = this.currentPage;
            if (page === 0) {
                this.currentPage = this.slideEls.length;
            } else if (page === this.slideEls.length + 1) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            if (this.loop) {
                if (this.delta === 0) {
                    this._setTranslate(self._getTranslateOfPage(this.lastPage));
                }
                setTimeout(function () {
                    self._setTranslate(self._getTranslateOfPage(page));
                    if (noAnimation) { return; }
                    self._onTransitionStart();
                }, 0);
            } else {
                this._setTranslate(this._getTranslateOfPage(page));
                if (noAnimation) { return; }
                this._onTransitionStart();
            }
        },
        isHorizontal: function isHorizontal() {
            return this.direction === HORIZONTAL;
        },
        isVertical: function isVertical() {
            return this.direction === VERTICAL;
        },
        _onTouchStart: function _onTouchStart(e) {
            this.startPos = this._getTouchPos(e);
            this.delta = 0;
            this.startTranslate = this._getTranslateOfPage(this.currentPage);
            this.startTime = new Date().getTime();
            this.dragging = true;
            this.transitionDuration = 0;

            document.addEventListener('touchmove', this._onTouchMove, false);
            document.addEventListener('touchend', this._onTouchEnd, false);
            document.addEventListener('mousemove', this._onTouchMove, false);
            document.addEventListener('mouseup', this._onTouchEnd, false);
        },
        _onTouchMove: function _onTouchMove(e) {
            this.delta = this._getTouchPos(e) - this.startPos;

            if (!this.performanceMode) {
                this._setTranslate(this.startTranslate + this.delta);
                this.$emit('slider-move', this._getTranslate());
            }

            if (this.isVertical() || this.isHorizontal() && Math.abs(this.delta) > 0) {
                e.preventDefault();
            }
        },
        _onTouchEnd: function _onTouchEnd(e) {
            this.dragging = false;
            this.transitionDuration = this.speed;
            var isQuickAction = new Date().getTime() - this.startTime < 1000;
            if (this.delta < -100 || (isQuickAction && this.delta < -15)) {
                this.next();
            } else if (this.delta > 100 || (isQuickAction && this.delta > 15)) {
                this.prev();
            } else {
                this._revert();
            }

            document.removeEventListener('touchmove', this._onTouchMove);
            document.removeEventListener('touchend', this._onTouchEnd);
            document.removeEventListener('mousemove', this._onTouchMove);
            document.removeEventListener('mouseup', this._onTouchEnd);
        },
        _onWheel: function _onWheel(e) {
            if (this.mousewheelControl) {
                // TODO Support apple magic mouse and trackpad.
                if (!this.transitioning) {
                    if (e.deltaY > 0) {
                        this.next();
                    } else {
                        this.prev();
                    }
                }
                if (this._isPageChanged()) { e.preventDefault(); }

            }
        },
        _revert: function _revert() {
            this.setPage(this.currentPage);
        },
        _getTouchPos: function _getTouchPos(e) {
            var key = this.isHorizontal() ? 'pageX' : 'pageY';
            return e.changedTouches ? e.changedTouches[0][key] : e[key];
        },
        _onTransitionStart: function _onTransitionStart() {
            this.transitioning = true;
            this.transitionDuration = this.speed;
            if (this._isPageChanged()) {
                this.$emit('slide-change-start', this.currentPage);
            } else {
                this.$emit('slide-revert-start', this.currentPage);
            }
        },
        _onTransitionEnd: function _onTransitionEnd() {
            this.transitioning = false;
            this.transitionDuration = 0;
            this.delta = 0;
            if (this._isPageChanged()) {
                this.$emit('slide-change-end', this.currentPage);
            } else {
                this.$emit('slide-revert-end', this.currentPage);
            }
        },
        _isPageChanged: function _isPageChanged() {
            return this.lastPage !== this.currentPage;
        },
        _setTranslate: function _setTranslate(value) {
            var translateName = this.isHorizontal() ? 'translateX' : 'translateY';
            this[translateName] = value;
        },
        _getTranslate: function _getTranslate() {
            var translateName = this.isHorizontal() ? 'translateX' : 'translateY';
            return this[translateName];
        },
        _getTranslateOfPage: function _getTranslateOfPage(page) {
            if (page === 0) { return 0; }

            var propName = this.isHorizontal() ? 'clientWidth' : 'clientHeight';
            return -[].reduce.call(this.slideEls, function (total, el, i) {
                return i > page - 2 ? total : total + el[propName];
            }, 0) + this.translateOffset;
        },
        _createLoop: function _createLoop() {
            var propName = this.isHorizontal() ? 'clientWidth' : 'clientHeight';
            var swiperWrapEl = this.$refs['swiper-wrap'];
            var duplicateFirstChild = swiperWrapEl.firstElementChild.cloneNode(true);
            var duplicateLastChild = swiperWrapEl.lastElementChild.cloneNode(true);
            swiperWrapEl.insertBefore(duplicateLastChild, swiperWrapEl.firstElementChild);
            swiperWrapEl.appendChild(duplicateFirstChild);
            this.translateOffset = -duplicateLastChild[propName];
        }
    }
});



/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(200)
__webpack_require__(201)

var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  "data-v-06031f34",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(202)

var Component = __webpack_require__(88)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  "data-v-0ede842b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "direction": "vertical",
      "paginationVisible": false,
      "mousewheel-control": true,
      "performance-mode": false,
      "pagination-visible": true,
      "pagination-clickable": true,
      "loop": false
    },
    on: {
      "slide-change-start": _vm.onSlideChangeStart
    }
  }, [_c('section', {
    staticClass: "swiper-roll weather-info"
  }, [_c('div', {
    style: ({
      'transition': 'All 0.4s ease-in-out',
      'transform': 'translate(0px, ' + _vm.cool.oldLocation + 'px)'
    }),
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "main-tmp"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.tmp)
    }
  }), _vm._v(" ℃")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "city-cond",
    domProps: {
      "textContent": _vm._s(_vm.basic.city + '-' + _vm.now.cond.txt)
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "swiper-roll weather-details"
  }, [_c('div', {
    staticClass: "sm-info",
    domProps: {
      "textContent": _vm._s(_vm.formatTime(_vm.basic.update.loc) + ' ' + _vm.now.tmp + '℃ ' + _vm.now.cond.txt)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    attrs: {
      "id": "tem-chart"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "detail-infos"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', [_c('span', [_vm._v("数据更新时间:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.basic.update.loc)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', [_c('span', [_vm._v("相对湿度:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.hum + ' %')
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("体感温度:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.fl + ' ℃')
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("降水量:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.pcpn + ' mm')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', [_c('span', [_vm._v("能见度:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.vis + ' km')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block"
  }, [_c('p', [_c('span', [_vm._v("风向风力:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.wind.dir + _vm.now.wind.sc + '级')
    }
  })]), _vm._v(" "), _c('p', [_c('span', [_vm._v("风速:")]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.now.wind.spd + ' kmph')
    }
  })])])])]), _vm._v(" "), _c('footer', [_vm._v("\n                Copyright © 2015-2017\n                "), _c('a', {
    attrs: {
      "href": "https://github.com/jeasonstudio"
    }
  }, [_vm._v(" JeasonStudio")])])])]), _vm._v(" "), _c('button', {
    staticClass: "refresh",
    on: {
      "click": function($event) {
        _vm.startFreshPlay()
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "33px",
      "height": "33px",
      "viewBox": "0 0 33 33",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Path")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-dasharray": "222.56 222.56",
      "stroke-dashoffset": "99.42"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17,3 C7.5,1.5 -3.5,15 7,26.5 C18,36.5 31.5,26.5 30,16.5 C26,16.5 22.7337186,16.2899602 20.5,14 C18.292338,11.7367524 16.5,9.5 17,3 Z",
      "id": "Path",
      "stroke": "#339FB7",
      "stroke-width": "4"
    }
  })])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper",
    class: [_vm.direction, {
      'dragging': _vm.dragging
    }],
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm._onTouchStart($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        _vm._onTouchStart($event)
      },
      "wheel": _vm._onWheel
    }
  }, [_c('div', {
    ref: "swiper-wrap",
    staticClass: "swiper-wrap",
    style: ({
      'transform': 'translate3d(' + _vm.translateX + 'px,' + _vm.translateY + 'px, 0)',
      'transition-duration': _vm.transitionDuration + 'ms'
    }),
    on: {
      "transitionend": _vm._onTransitionEnd
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginationVisible),
      expression: "paginationVisible"
    }],
    staticClass: "swiper-pagination"
  }, _vm._l((_vm.slideEls), function(slide, index) {
    return _c('span', {
      staticClass: "swiper-pagination-bullet",
      class: {
        'active': (index + 1) === _vm.currentPage
      },
      on: {
        "click": function($event) {
          _vm.paginationClickable && _vm.setPage(index + 1)
        }
      }
    })
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(182);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("5c7684bc", content, true);

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(183);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("41498299", content, true);

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(64)("3e4847d9", content, true);

/***/ })

},[185]);


// WEBPACK FOOTER //
// app.00c9c09b13e83c5dd2c5.js